// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import theme from '../../styled-components/dark';

const Wrap = styled.div`
  height: 2em;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  background-color: ${theme.BetGroupHeader.backgroundColor};
  border-radius: 1rem 1rem 0 0;
`;

const LabelWrapper = styled.div`
  position: relative;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ $nbLabels }) => `${100 / $nbLabels}%`};

  & > p {
    color: ${theme.BetGroupHeader.color};

    font-size: 0.85em;
    letter-spacing: 0.1em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0%;
  }

  padding: 0 0.6em;

  &:not(:last-child) {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 1px;

      background-color: ${theme.BetGroupHeader.separatorColor};
    }
  }
`;

type BetGroupProps = {
  className?: string;
  labels: Array<string>;
};

const BetGroupHeader = ({ className, labels }: BetGroupProps) => {
  return labels ? (
    <Wrap className={className}>
      {labels.map((label) => (
        <LabelWrapper key={label} $nbLabels={labels.length}>
          <p>{label}</p>
        </LabelWrapper>
      ))}
    </Wrap>
  ) : null;
};

export default BetGroupHeader;
